import type { InventoriesQueryQuery } from '@/graphql/generated/seller/graphql';
import { ListData } from '@/shared/types';

export type InventoryListItem = {
  id: string;
  skuId: string;
  skuName?: string | null;
  skuDescription?: string | null;
  locationId: string;
  locationName?: string | null;
  status: string;
  qtyExpected: number;
  qtyOnHand: number;
  qtyReserved: number;
  qtyAvailable: number;
  isSkuArchived: boolean;
};

export class InventoryListMapper {
  static toData(response: InventoriesQueryQuery): ListData<InventoryListItem> {
    const total = response?.inventoriesAggregate?._count ?? 0;
    const data = Array.isArray(response.inventories)
      ? response.inventories.map((inventory) => {
          const { sku, ...rest } = inventory;
          return {
            isSkuArchived: !!sku?.archivedAt,
            ...rest,
          };
        })
      : [];

    return {
      data,
      total,
    };
  }
}
